/* asv2 */
export const LANGUAGE_COOKIE_NAME = 'AC_LANG';
export const CURRENCY_COOKIE_NAME = 'AC_CURR';
export const DARK_MODE_COOKIE_NAME = 'AC_DARK';
export const DEVICE_COOKIE_NAME = 'DS';
export const LOGIN_SESSION_COOKIE_NAME = 'LS';
export const ACTIVE_ORGANIZATION_ID_COOKIE = 'activeOrgId';

/* next-intl */
export const LOCALE_COOKIE_NAME = 'NEXT_LOCALE';

/* Cookie expiries */
export const COOKIE_EXPIRY_SECONDS = 34560000;
export const COOKIE_EXPIRY_ONE_DAY_IN_MS = 86400000;
export const COOKIE_EXPIRY_DAYS = 400;

/* Search preferences */
export const RESULTS_PER_PAGE_COOKIE_NAME = 'as-results-per-page';

/* Experiments */
export const EXPERIMENT_VARIANTS_HEADER = 'as-experiment-variants';
export const EXPERIMENTS_OVERRIDE_COOKIE = 'as-experiment-override';
